<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Create your custom {{gridState.gridId?.toLowerCase()}} view page</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" [formGroup]="formGroup">
  <div class="row kt-padding-15">
    <div class="col-md-8 d-flex kt-margin-b-10" *ngIf="gridState.name !== undefined">
      <div class="strong kt-padding-t-10 kt-padding-r-20">Name</div>
      <input class="form-control input-sm" formControlName="name">
    </div>
    <div class="col-md-4 kt-padding-10">
      <label class="kt-checkbox" [ngClass]="formGroup.value.isDefault ? 'kt-checkbox--solid kt-checkbox--brand' : ''">
        <input type="checkbox" formControlName="isDefault"> Default view
        <span></span>
      </label>
    </div>
  </div>

  <div class="row" cdkDropListGroup>
    <div class="col-8">
      <div class="strong medium-text kt-margin-b-15 kt-label-font-color-2">CUSTOMIZE COLUMNS</div>
      <div class="row">
        <div class="col-6">
          <div class="section">
            <div class="strong kt-font-brand kt-margin-b-10">{{ 'GENERAL.MESSAGES.HIDDEN_COLUMNS' | translate }}</div>
            <div cdkDropList [cdkDropListData]="hiddenColumns" class="columns-list"
              (cdkDropListDropped)="drop($event, false)">
              <div class="column-box" *ngFor="let col of hiddenColumns" cdkDrag>
                <ng-container *ngTemplateOutlet="col.titleTemplate; context: { col: col }">
                </ng-container>
                <span *ngIf="col.titleTemplate == undefined">{{ col.title || ((col.name || '').split(col.reg).join(' ') | titlecase) }}</span>
                <button class="btn btn-sm btn-icon btn-outline-secondary btn-circle mr-3" (click)="move(col)">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="section">
            <div class="strong kt-font-brand kt-margin-b-10">{{ 'GENERAL.MESSAGES.VISIBLE_COLUMNS' | translate }}</div>
            <div cdkDropList [cdkDropListData]="visibleColumns" [class.columns-list]="HasVisibleColumns"
              (cdkDropListDropped)="drop($event, true)">
              <div class="column-box" *ngFor="let col of visibleColumns" cdkDrag>
                <ng-container *ngTemplateOutlet="col.titleTemplate; context: { col: col }">
                </ng-container>
                <div *ngIf="col.titleTemplate == undefined" class="kt-margin-5 strong">
                  {{ col.title || ((col.name || '').split(col.reg).join(' ') | titlecase) }}</div>
              </div>
              <div *ngIf="!HasVisibleColumns" class="kt-padding-5 row kt-padding-t-40 kt-padding-b-40">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                  Drag columns from the hidden columns on the left to create your custom view, and drag up and down to reorder columns
                </div>
                <div class="col-lg-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="strong medium-text kt-margin-b-15 kt-label-font-color-2">DEFAULT FILTER SETTINGS</div>
      <div *ngIf="!disabled.locations">
        <div class="dropdown-header" [class.expanded]="dropdowns.locations"
          (click)="dropdowns.locations = !dropdowns.locations">{{gridState.gridColumns?.locations?.length ? 'Selected' : 'All'}} Locations</div>
        <div class="dropdown-content" *ngIf="dropdowns.locations">
          <div *ngFor="let location of locations.getAll()">
            <label class="kt-checkbox"
              [ngClass]="gridState.gridColumns.locations.includes(location.id) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="gridState.gridColumns.locations.includes(location.id)"
                (change)="locationSelected($event, location.id)"> {{location.name}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="!disabled.stores">
        <div class="dropdown-header" [class.expanded]="dropdowns.stores"
        (click)="dropdowns.stores = !dropdowns.stores">{{(gridState.gridColumns.storesEntityMap?.length) ? 'Selected' : 'All'}} Stores</div>
        <div class="dropdown-content" *ngIf="dropdowns.stores">
          <div *ngFor="let store of storesEntitiesState.entitiesArray">
            <label class="kt-checkbox"
              [ngClass]="(gridState.gridColumns.storesEntityMap || []).includes(store.id) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.storesEntityMap || []).includes(store.id)"
                (change)="storeSelected($event, store.id)"> {{store.name}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="!disabled.tags">
        <div class="dropdown-header" [class.expanded]="dropdowns.tags"
        (click)="dropdowns.tags = !dropdowns.tags">{{(gridState.gridColumns.tags?.length) ? 'Selected' : 'All'}} Tags</div>
        <div class="dropdown-content" *ngIf="dropdowns.tags">
          <div>
            <label class="kt-checkbox"
              [ngClass]="isSelectAllTagsChecked() ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="isSelectAllTagsChecked()"
                (change)="tagSelected($event, -2)">Select All
              <span></span>
            </label>
          </div>
          <div>
            <label class="kt-checkbox" [attr.title]="supportsProductStatusTags ? listingStatusHint : null"
              [ngClass]="(gridState.gridColumns.tags || []).includes(-1) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.tags || []).includes(-1)"
                (change)="tagSelected($event, -1)">Active
              <span></span>
            </label>
          </div>
          <div>
            <label class="kt-checkbox" [attr.title]="supportsProductStatusTags ? listingStatusHint : null"
              [ngClass]="(gridState.gridColumns.tags || []).includes(0) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.tags || []).includes(0)"
                (change)="tagSelected($event, 0)">Inactive
              <span></span>
            </label>
          </div>
          <div *ngIf="supportsProductStatusTags">
            <label class="kt-checkbox" [attr.title]="productStatusHint"
              [ngClass]="(gridState.gridColumns.tags || []).includes(-3) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.tags || []).includes(-3)"
                (change)="tagSelected($event, -3)">Product Active
              <span></span>
            </label>
          </div>
          <div *ngIf="supportsProductStatusTags">
            <label class="kt-checkbox" [attr.title]="productStatusHint"
              [ngClass]="(gridState.gridColumns.tags || []).includes(-4) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.tags || []).includes(-4)"
                (change)="tagSelected($event, -4)">Product Inactive
              <span></span>
            </label>
          </div>
          <div *ngFor="let tag of tags.getAll()">
            <label class="kt-checkbox"
              [ngClass]="(gridState.gridColumns.tags || []).includes(tag.tagId) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.tags || []).includes(tag.tagId)"
                (change)="tagSelected($event, tag.tagId)"> {{tag.name}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="!disabled.tags">
        <div class="dropdown-header" [class.expanded]="dropdowns.excludedTags"
        (click)="dropdowns.excludedTags = !dropdowns.excludedTags">{{(gridState.gridColumns.excludedTags?.length) ? 'Selected' : 'No'}} Exclude Tags</div>
        <div class="dropdown-content" *ngIf="dropdowns.excludedTags">
          <div class="small text-muted kt-margin-b-10">Exclude products with these tags. Untagged products remain visible.</div>
          <div>
            <label class="kt-checkbox"
              [ngClass]="isSelectAllExcludedTagsChecked() ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="isSelectAllExcludedTagsChecked()"
                (change)="excludedTagSelected($event, -2)">Select All
              <span></span>
            </label>
          </div>
          <div>
            <label class="kt-checkbox" [attr.title]="supportsProductStatusTags ? listingStatusHint : null"
              [ngClass]="(gridState.gridColumns.excludedTags || []).includes(-1) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.excludedTags || []).includes(-1)"
                (change)="excludedTagSelected($event, -1)">Active
              <span></span>
            </label>
          </div>
          <div>
            <label class="kt-checkbox" [attr.title]="supportsProductStatusTags ? listingStatusHint : null"
              [ngClass]="(gridState.gridColumns.excludedTags || []).includes(0) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.excludedTags || []).includes(0)"
                (change)="excludedTagSelected($event, 0)">Inactive
              <span></span>
            </label>
          </div>
          <div *ngIf="supportsProductStatusTags">
            <label class="kt-checkbox" [attr.title]="productStatusHint"
              [ngClass]="(gridState.gridColumns.excludedTags || []).includes(-3) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.excludedTags || []).includes(-3)"
                (change)="excludedTagSelected($event, -3)">Product Active
              <span></span>
            </label>
          </div>
          <div *ngIf="supportsProductStatusTags">
            <label class="kt-checkbox" [attr.title]="productStatusHint"
              [ngClass]="(gridState.gridColumns.excludedTags || []).includes(-4) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.excludedTags || []).includes(-4)"
                (change)="excludedTagSelected($event, -4)">Product Inactive
              <span></span>
            </label>
          </div>
          <div *ngFor="let tag of tags.getAll()">
            <label class="kt-checkbox"
              [ngClass]="(gridState.gridColumns.excludedTags || []).includes(tag.tagId) ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="(gridState.gridColumns.excludedTags || []).includes(tag.tagId)"
                (change)="excludedTagSelected($event, tag.tagId)"> {{tag.name}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="viewByOptions">
        <div class="dropdown-header" [class.expanded]="dropdowns.grouping"
        (click)="dropdowns.grouping = !dropdowns.grouping">View By</div>
        <div class="dropdown-content" *ngIf="dropdowns.grouping">
          <div *ngFor="let viewByOption of viewByOptions">
            <label class="kt-radio"
              [ngClass]="gridState.gridColumns.viewBy == viewByOption.id ? 'kt-radio--solid kt-radio--brand' : null">
              <input type="radio" [checked]="gridState.gridColumns.viewBy == viewByOption.id" name="viewBy"
                (click)="gridState.gridColumns.viewBy = viewByOption.id"> {{viewByOption.label}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div>
        <div class="dropdown-header" [class.expanded]="dropdowns.sort"
          (click)="dropdowns.sort = !dropdowns.sort">Sort By</div>
        <div class="dropdown-content" *ngIf="dropdowns.sort">
          <div class="d-flex">
            <label class="kt-radio kt-margin-r-20"
              [ngClass]="gridState.gridColumns.sort === 'asc' ? 'kt-radio--solid kt-radio--brand' : null">
              <input type="radio" [checked]="gridState.gridColumns.sort === 'asc'" name="sort"
                (click)="gridState.gridColumns.sort = 'asc'"><i class="fa fa-angle-up"></i>
              <span></span>
            </label>
            <label class="kt-radio"
              [ngClass]="gridState.gridColumns.sort === 'desc' ? 'kt-radio--solid kt-radio--brand' : null">
              <input type="radio" [checked]="gridState.gridColumns.sort === 'desc'" name="sort"
                (click)="gridState.gridColumns.sort = 'desc'"><i class="fa fa-angle-down"></i>
              <span></span>
            </label>
          </div>
          <div *ngFor="let sortByOption of filterOptions">
            <label class="kt-radio"
              [ngClass]="gridState.gridColumns.sortBy == sortByOption.field ? 'kt-radio--solid kt-radio--brand' : null">
              <input type="radio" [checked]="gridState.gridColumns.sortBy == sortByOption.field" name="sortBy"
                (click)="gridState.gridColumns.sortBy = sortByOption.field"> {{sortByOption.title}}
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div>
        <div class="dropdown-header" [class.expanded]="dropdowns.filters"
        (click)="dropdowns.filters = !dropdowns.filters">Advanced filter</div>
        <div class="dropdown-content" *ngIf="dropdowns.filters">
          <filters [filterOptions]="filterOptions" [selectedFilters]="selectedFilters"
            [savedFilters]="savedFilters"></filters>
        </div>
      </div>
      <div *ngIf="supportsSkuExclusions">
        <div class="dropdown-header" [class.expanded]="dropdowns.skuExclusions"
          (click)="dropdowns.skuExclusions = !dropdowns.skuExclusions">SKU exclusions</div>
        <div class="dropdown-content" *ngIf="dropdowns.skuExclusions">
          <div>
            <label class="kt-checkbox"
              [ngClass]="gridState.gridColumns.hideAmznGrSkus ? 'kt-checkbox--solid kt-checkbox--brand' : null">
              <input type="checkbox" [checked]="gridState.gridColumns.hideAmznGrSkus"
                (change)="gridState.gridColumns.hideAmznGrSkus = $any($event.target).checked"> Hide amzn.gr*
              <span></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger kt-margin-r-50" [disabled]="saving" (click)="delete(confirmation)"
    *ngIf="gridState.id">{{ 'GENERAL.BUTTONS.DELETE' | translate }}</button>
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">{{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
  <button type="button" class="btn btn-brand" [disabled]="saving" (click)="save()">{{ 'GENERAL.BUTTONS.SAVE' | translate }}</button>
</div>
<ng-template #confirmation let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Delete the {{gridState.gridId?.toLowerCase()}} view page?</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<input type="hidden">
		<p>Do you really want to delete the the {{gridState.gridId?.toLowerCase()}} view page?</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary"
			(click)="modal.dismiss()">{{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
		<button type="button" class="btn btn-danger"
			(click)="modal.close()">{{ 'GENERAL.BUTTONS.DELETE' | translate }}</button>
	</div>
</ng-template>
